'use client';

import { c as _c } from "react/compiler-runtime";
import { setSelectedBenefit } from '@lib/store/slices/EqualizerSlice';
import getValidbenefits from '@lib/tools/_getValidBenefits';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PaymentCard from './components/payment-card/PaymentCard';
import styles from './Equalizer.module.scss';
const Equalizer = t0 => {
  const $ = _c(23);
  const {
    flat
  } = t0;
  const dispatch = useDispatch();
  const {
    currentData
  } = useSelector(_temp);
  let t1;
  if ($[0] !== flat) {
    t1 = getValidbenefits(flat);
    $[0] = flat;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const validMortgageBenefits = t1;
  let t2;
  if ($[2] !== dispatch || $[3] !== flat?.benefits?.cash || $[4] !== flat?.redPrice) {
    t2 = () => {
      if (flat?.benefits?.cash?.length > 0) {
        if (flat?.redPrice === true) {
          const selectedBenefit = flat?.benefits?.cash?.find(_temp2) || [];
          dispatch(setSelectedBenefit(selectedBenefit));
        } else {
          dispatch(setSelectedBenefit(flat?.benefits?.cash[0]));
        }
      }
    };
    $[2] = dispatch;
    $[3] = flat?.benefits?.cash;
    $[4] = flat?.redPrice;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== flat) {
    t3 = [flat];
    $[6] = flat;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  const t4 = flat?.benefits?.cash?.length > 0 ? flat?.benefits?.cash[0] : null;
  let t5;
  if ($[8] !== currentData?.currentMortgageBenefit || $[9] !== validMortgageBenefits?.length) {
    t5 = validMortgageBenefits?.length > 0 && Object.keys(currentData?.currentMortgageBenefit).length === 0 ? {
      group: "choice-mortgage",
      id: "01",
      name: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u0438\u043F\u043E\u0442\u0435\u043A\u0438"
    } : null;
    $[8] = currentData?.currentMortgageBenefit;
    $[9] = validMortgageBenefits?.length;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== currentData?.currentMortgageBenefit) {
    t6 = Object.keys(currentData?.currentMortgageBenefit).length > 0 ? currentData?.currentMortgageBenefit : null;
    $[11] = currentData?.currentMortgageBenefit;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = [t4, t5, t6].filter(_temp3);
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const benefits = t7;
  const showBenefits = benefits?.length > 0 && !flat?.redPrice;
  let t8;
  if ($[17] !== benefits || $[18] !== showBenefits || $[19] !== validMortgageBenefits) {
    t8 = showBenefits && <div className={styles.equalizer_container}>{benefits?.map(benefit => <PaymentCard key={benefit?.id} benefit={benefit} validMortgageBenefits={validMortgageBenefits} />)}</div>;
    $[17] = benefits;
    $[18] = showBenefits;
    $[19] = validMortgageBenefits;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t8) {
    t9 = <>{t8}</>;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default Equalizer;
function _temp(state) {
  return state?.equalizer;
}
function _temp2(program) {
  return program?.redPrice === true;
}
function _temp3(el) {
  return el;
}